import { Button, Heading, Icon, IconButton, Input, Select, Spinner, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { BsExclamationLg } from "react-icons/bs";
import { FaArrowLeft, FaArrowRight, FaFilter, FaSync } from "react-icons/fa";
import { RiFilterOffFill, RiFolder2Fill } from "react-icons/ri";
import { GET } from "../../../utils/ApiRequestProvider";


export default function DocumentsProcessingSummary() {
    const toast = useToast();
    const [invs, setInvs] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(false);

    const convertDate = (date: string | null) => (date ? new Date(date).toLocaleString() : '');

    async function FetchList() {
        setLoading(true);
        try {
            const res = await GET(`/api/internal/processing-summary`);
            setInvs(res.data.documents ?? []);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error', isClosable: false, duration: 1000, position: 'top-right'
            });
        }
        setLoading(false);
    }

    useEffect(() => {
        FetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={RiFolder2Fill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Processed Document Summary</Heading>
                            <Text fontSize={'sm'}>Here you can view all your processed documents summary.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                {/* <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <InputGroup>
                            <Input placeholder='Search' />
                            <InputRightElement children={<FaSearch color={'#ababab'} />} />
                        </InputGroup>
                        <Select>
                            <option value="option1">All Entities</option>
                            <option value="option2">Default Entities</option>
                            <option value="option3">Test Entities</option>
                        </Select>
                        <IconButton
                            aria-label='Refresh'
                            rounded={'full'}
                            icon={<FaSync />}
                        />
                    </Stack>
                </Stack> */}
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <Stack
                    w={'full'}
                    spacing={2}
                    align={'center'}
                    direction={'row'}
                    justify={'center'}
                >
                    <Select
                        w={'100%'}
                        size={'sm'}
                        placeholder="Select an Organization"
                    >
                        <option value="option1">Inam Space Research Organization</option>
                        <option value="option2">Entry Bot</option>
                        <option value="option3">ABC Chartered Accountants</option>
                    </Select>


                    <Select
                        w={'100%'}
                        size={'sm'}
                        placeholder="Select a User's Email"
                    >
                        <option value="option1">stdhamza26@gmail.com</option>
                        <option value="option2">hadibro@entrybot.com</option>
                        <option value="option3">inaamneildegrassetyson@gmail.com</option>
                    </Select>

                    <Input
                        size={'sm'}
                        type={'date'}
                        placeholder={'Start Date'}
                    />

                    <Input
                        size={'sm'}
                        type={'date'}
                        placeholder={'End Date'}
                    />
                </Stack>
                <Stack
                    w={'full'}
                    spacing={2}
                    align={'center'}
                    direction={'row'}
                    justify={'flex-end'}
                >
                    <Button
                        w={'full'}
                        size={'sm'}
                        color={'white'}
                        bg={'blue.400'}
                        leftIcon={<FaSync />}
                        _hover={{ bg: 'blue.500' }}
                        _active={{ bg: 'blue.600' }}
                    >
                        Refresh
                    </Button>

                    <Button
                        w={'full'}
                        size={'sm'}
                        color={'white'}
                        bg={'blue.400'}
                        leftIcon={<FaFilter />}
                        _hover={{ bg: 'blue.500' }}
                        _active={{ bg: 'blue.600' }}
                    >
                        Apply Filter
                    </Button>

                    <Button
                        w={'full'}
                        size={'sm'}
                        color={'white'}
                        bg={'gray.400'}
                        leftIcon={<RiFilterOffFill />}
                        _hover={{ bg: 'gray.500' }}
                        _active={{ bg: 'gray.600' }}
                    >
                        Clear Filter
                    </Button>

                    <Button
                        w={'full'}
                        size={'sm'}
                        color={'white'}
                        bg={'green.400'}
                        leftIcon={<BsExclamationLg />}
                        _hover={{ bg: 'green.500' }}
                        _active={{ bg: 'green.600' }}
                    >
                        Bulk Send Web/Mobile Email
                    </Button>
                </Stack>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} zIndex={1} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    Uploaded By
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Organization Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Invoice Processed
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Statements Processed
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    In Process
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    First Upload Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Last Upload Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Last Sent
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Last Sent Elapsed Time
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Email/Web/Mobile
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Web/Mobile
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.length === 0 ? (
                                    <Tr>
                                        <Td colSpan={11} textAlign={'center'}>
                                            {loading ? <Spinner size={'sm'} color={'primary.400'} /> : 'No Data Available'}
                                        </Td>
                                    </Tr>
                                ) :
                                invs.map((inv, i) => (
                                    <Tr key={i}>
                                        <Td>{inv.uploadedBy}</Td>
                                        <Td>{inv.orgName}</Td>
                                        <Td>{inv.invoiceProcessed}</Td>
                                        <Td>{inv.statementsProcessed}</Td>
                                        <Td>{inv.inProcess}</Td>
                                        <Td>{convertDate(inv.firstUploadDate)}</Td>
                                        <Td>{convertDate(inv.lastUploadDate)}</Td>
                                        <Td>{convertDate(inv.lastSent)}</Td>
                                        <Td>{inv.lastSentElapsedTime}</Td>
                                        <Td>
                                            <Button
                                                w={'full'}
                                                size={'sm'}
                                                bg={'blue.400'}
                                                color={'white'}
                                                rounded={'none'}
                                                _hover={{ bg: 'blue.500' }}
                                                _active={{ bg: 'blue.600' }}
                                            >
                                                Send
                                            </Button>
                                        </Td>
                                        <Td>
                                            <Button
                                                w={'full'}
                                                size={'sm'}
                                                bg={'blue.400'}
                                                color={'white'}
                                                rounded={'none'}
                                                _hover={{ bg: 'blue.500' }}
                                                _active={{ bg: 'blue.600' }}
                                            >
                                                Send
                                            </Button>
                                        </Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing {invs.length} of {invs.length} results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select defaultValue={10}>
                            <option value={5}>5 Per Page</option>
                            <option value={10}>10 Per Page</option>
                            <option value={25}>25 Per Page</option>
                            <option value={50}>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}